import {API} from "./config";
import axiosClient, {
  axiosClientDelivery,
  axiosClientImage,
  axiosClientLogin,
  axiosClientV2,
  handleRequest
} from "./axiosClient";
import {base64ToFile, cleanNumber, cleanObject, hashPassword, objectToQueryString} from "../utils";
import {localGetItem} from "../utils/localStorage";
import {LOCAL_STORAGE_KEY} from "../constants";

export const merchantRegister = ({phoneNumber}) => {
  const uri = API.merchant.registerStart
  const params = {
    username: phoneNumber
  };
  return handleRequest(axiosClientLogin.post(uri, params));
}

export const merchantConfirmOTP = ({confirmId, otp}) => {
  const uri = API.merchant.confirmOTP
  const params = {
    confirmId: confirmId,
    otp
  };
  return handleRequest(axiosClientLogin.post(uri, params));
}

export const merchantResendOTP = ({confirmId, phoneNumber}) => {
  const uri = API.merchant.resendOTP
  const params = {
    phoneNumber: confirmId,
    confirmId: confirmId
  };
  return handleRequest(axiosClient.post(uri, params));
}

export const merchantRegisterInputPwd = ({confirmId, password}) => {
  const uri = API.merchant.registerInputPwd
  const params = {
    confirmId: confirmId,
    password: hashPassword(password)
  };
  return handleRequest(axiosClientLogin.post(uri, params));
}

export const merchantForgotPassword = ({phoneNumber}) => {
  const uri = API.merchant.forgotPassword
  const params = {
    username: phoneNumber
  };
  return handleRequest(axiosClientLogin.post(uri, params));
}

export const merchantLogin = ({phoneNumber, password}) => {
  const uri = API.merchant.merchantLogin
  const params = {
    username: phoneNumber,
    password: hashPassword(password)
  };
  return handleRequest(axiosClientLogin.post(uri, params));
}

export const merchantOnboarding = ({
                                     ownerName: owner_name,
                                     phoneNumber: merchant_phone_number,
                                     merchantName: merchant_name,
                                     address: merchant_address,
                                     province,
                                     district,
                                     commune,
                                     email,
                                     description,
                                     avatar,
                                     goodsIndustries: goods_industries,
                                     uploadedAttachments: uploaded_attachments
                                   }) => {
  const uri = API.merchant.merchantOnboarding
  const params = {
    owner_name,
    email,
    merchant_phone_number,
    merchant_name,
    merchant_address,
    province,
    district,
    commune,
    description,
    avatar,
    goods_industries,
    uploaded_attachments
  };

  return handleRequest(axiosClient.post(uri, params));
}

export const changePassword = ({oldPassword, newPassword}) => {
  const uri = API.merchantCMS.changePassword
  const params = {
    old_password: hashPassword(oldPassword),
    new_password: hashPassword(newPassword)
  };
  return handleRequest(axiosClient.post(uri, params));
}

export const helperUpload = ({files}) => {
  const uri = API.helper.upload
  const params = new FormData();
  (files || []).forEach(file => params.append('files', file));
  return handleRequest(axiosClient.post(uri, params));
}

export const getProvince = () => {
  const uri = API.location
  return handleRequest(axiosClientDelivery.get(uri));
}

export const getDistrict = ({provinceId}) => {
  const uri = API.location
  return handleRequest(axiosClientDelivery.get(uri, {params: {parentCode: provinceId, level: 1}}));
}

export const getCommunes = ({districtId}) => {
  const uri = API.location
  return handleRequest(axiosClientDelivery.get(uri, {params: {parentCode: districtId, level: 2}}));
}

export const getMerchantProfile = () => {
  const uri = API.merchantCMS.profile
  return handleRequest(axiosClient.get(uri));
}

export const updateMerchantProfile = (
  {
    ownerName: owner_name,
    phoneNumber: phone_number,
    merchantName: merchant_name,
    avatarUrl: avatar_url,
    email,
    address,
    province,
    district,
    commune,
    description,
    avatar,
    goodsIndustries: goods_industries,
    uploadedAttachments: uploaded_attachments
  }
) => {
  const uri = API.merchantCMS.profile

  const params = {
    owner_name,
    phone_number,
    merchant_name,
    email,
    address,
    province,
    district,
    commune,
    description,
    avatar,
    goods_industries,
    avatar_url,
    uploaded_attachments
  };

  return handleRequest(axiosClient.patch(uri, params));
}

export const getProductList = (params) => {
  const uri = API.merchantCMS.products + '?' + objectToQueryString(params || {})
  return handleRequest(axiosClientV2.get(uri, params));
}

export const getProductCategories = () => {
  const uri = API.medusa.productCategories + '?parent_category_id=null&include_descendants_tree=true'
  return handleRequest(axiosClient.get(uri));
}

export const createProduct = ({
                                productName: product_name,
                                productDetail: product_detail,
                                categoryId: category_id,
                                minPrice: min_price,
                                maxPrice: max_price,
                                minOrderQty: min_order_qty,
                                unitOfMeasure: unit_of_measure,
                                imagesUploaded: images_uploaded,
                                thumbnail,
                                retails,
                              }) => {
  const uri = API.merchantCMS.products
  const params = {
    product_name,
    product_detail,
    category_id,
    images_uploaded,
    thumbnail,
    retails,
    wholesale: {
      min_price: cleanNumber(min_price),
      max_price: cleanNumber(max_price),
      min_order_qty: cleanNumber(min_order_qty),
      unit_of_measure: unit_of_measure,
    }
  };
  return handleRequest(axiosClientV2.post(uri, cleanObject(params)));
}

export const getProductDetail = ({productId}) => {
  const uri = API.medusa.productsDetail + '/' + productId
  return handleRequest(axiosClientV2.get(uri));
}

export const updateGeneralInfoProduct = ({
                                           id,
                                           productName: product_name,
                                           productDetail: product_detail,
                                           categoryId: category_id,
                                           imagesUploaded: images_uploaded,
                                           thumbnail
                                         }) => {
  const uri = API.merchant.updateProduct + '/' + id + '/general-info'
  const params = {
    product_name,
    product_detail,
    category_id,
    images_uploaded,
    thumbnail
  };
  return handleRequest(axiosClientV2.post(uri, params));
}
export const updateSaleTypesProduct = ({
                                         id,
                                         items = [],
                                         is_disable_wholesale,
                                       }) => {
  const uri = API.merchant.updateProduct + '/' + id + '/sale-types'
  const params = {items};
  if (is_disable_wholesale === true) {
    params.is_disable_wholesale = true;
  }
  return handleRequest(axiosClientV2.post(uri, params));
}

export const updateProductStatus = ({productId, status}) => {
  const uri = API.merchant.updateProduct + '/' + productId + '/status'
  const params = {
    status
  };
  return handleRequest(axiosClient.patch(uri, params));
}

export const deleteProductItem = ({productId}) => {
  const uri = API.merchantCMS.products + '/' + productId;
  return handleRequest(axiosClient.delete(uri));
}

export const countStatusProduct = () => {
  const uri = API.merchantCMS.countStatus
  return handleRequest(axiosClient.get(uri));
}

export const changePasswordProfile = ({oldPassword, newPassword}) => {
  const uri = API.merchantCMS.changePassword
  const params = {
    oldPassword: hashPassword(oldPassword),
    newPassword: hashPassword(newPassword)
  };
  return handleRequest(axiosClientLogin.post(uri, params));
}

export const resetPassword = ({confirmId, password}) => {
  const uri = API.merchant.resetPassword
  const params = {
    confirmId: confirmId,
    password: hashPassword(password)
  };
  return handleRequest(axiosClientLogin.post(uri, params));
}

export const uploadImage = async ({files}) => {
  const uri = API.helper.image + '?format=webp'
  const params = new FormData();
  (files || []).forEach(file => params.append('images', file));
  const uploadData = await handleRequest(axiosClientImage.post(uri, params, {headers: {'Content-Type': 'multipart/form-data'}}));
  if (!uploadData.success && uploadData.status === 413) {
    throw new Error('Dung lượng ảnh vượt quá giới hạn cho phép. Vui lòng kiểm tra lại.');
  }
  const images = uploadData?.data?.images || []
  return (images || []).map((image, index) => base64ToFile(image, 'application/octet-stream', (files?.[index]?.name || '').replace(/\.[^/.]+$/, ".webp")));
}

export const refresh = () => {
  const uri = API.merchant.refresh
  const refreshToken = localGetItem({key: LOCAL_STORAGE_KEY.REFRESH_TOKEN, type: 'string'})
  const params = {
    token: localGetItem({key: LOCAL_STORAGE_KEY.TOKEN, type: 'string'})
  };
  return handleRequest(axiosClientLogin.post(uri, params, {headers: {'Authorization': 'Bearer ' + refreshToken}}));
}
